// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #EFEFEF; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Montserrat, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: Source Code Pro, Menlo, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #818181; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.\\!visible {
  visibility: visible !important;
}

.visible {
  visibility: visible;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-0 {
  inset: 0px;
}

.inset-1\\.5 {
  inset: 0.375rem;
}

.inset-2 {
  inset: 0.5rem;
}

.inset-x-4 {
  left: 1rem;
  right: 1rem;
}

.inset-y-0 {
  top: 0px;
  bottom: 0px;
}

.-bottom-\\[7px\\] {
  bottom: -7px;
}

.-right-0\\.5 {
  right: -0.125rem;
}

.-right-1 {
  right: -0.25rem;
}

.-right-12 {
  right: -3rem;
}

.-right-24 {
  right: -6rem;
}

.-right-3 {
  right: -0.75rem;
}

.-top-0 {
  top: -0px;
}

.-top-0\\.5 {
  top: -0.125rem;
}

.-top-1 {
  top: -0.25rem;
}

.-top-2 {
  top: -0.5rem;
}

.bottom-0 {
  bottom: 0px;
}

.bottom-1\\/3 {
  bottom: 33.333333%;
}

.bottom-1\\/4 {
  bottom: 25%;
}

.bottom-2 {
  bottom: 0.5rem;
}

.bottom-20 {
  bottom: 5rem;
}

.bottom-24 {
  bottom: 6rem;
}

.bottom-4 {
  bottom: 1rem;
}

.bottom-\\[20px\\] {
  bottom: 20px;
}

.bottom-\\[60px\\] {
  bottom: 60px;
}

.bottom-\\[80px\\] {
  bottom: 80px;
}

.bottom-full {
  bottom: 100%;
}

.left-0 {
  left: 0px;
}

.left-1 {
  left: 0.25rem;
}

.left-1\\/2 {
  left: 50%;
}

.left-1\\/3 {
  left: 33.333333%;
}

.left-1\\/4 {
  left: 25%;
}

.left-10 {
  left: 2.5rem;
}

.left-16 {
  left: 4rem;
}

.left-2 {
  left: 0.5rem;
}

.left-3 {
  left: 0.75rem;
}

.left-4 {
  left: 1rem;
}

.left-8 {
  left: 2rem;
}

.left-\\[-55px\\] {
  left: -55px;
}

.right-0 {
  right: 0px;
}

.right-1 {
  right: 0.25rem;
}

.right-1\\.5 {
  right: 0.375rem;
}

.right-1\\/3 {
  right: 33.333333%;
}

.right-1\\/4 {
  right: 25%;
}

.right-12 {
  right: 3rem;
}

.right-2 {
  right: 0.5rem;
}

.right-20 {
  right: 5rem;
}

.right-3 {
  right: 0.75rem;
}

.right-4 {
  right: 1rem;
}

.right-5 {
  right: 1.25rem;
}

.right-8 {
  right: 2rem;
}

.right-\\[-55px\\] {
  right: -55px;
}

.right-\\[16px\\] {
  right: 16px;
}

.right-full {
  right: 100%;
}

.top-0 {
  top: 0px;
}

.top-1 {
  top: 0.25rem;
}

.top-1\\/2 {
  top: 50%;
}

.top-1\\/3 {
  top: 33.333333%;
}

.top-1\\/4 {
  top: 25%;
}

.top-10 {
  top: 2.5rem;
}

.top-12 {
  top: 3rem;
}

.top-16 {
  top: 4rem;
}

.top-2 {
  top: 0.5rem;
}

.top-2\\/3 {
  top: 66.666667%;
}

.top-20 {
  top: 5rem;
}

.top-24 {
  top: 6rem;
}

.top-3\\/4 {
  top: 75%;
}

.top-32 {
  top: 8rem;
}

.top-4 {
  top: 1rem;
}

.top-40 {
  top: 10rem;
}

.top-5 {
  top: 1.25rem;
}

.top-60 {
  top: 15rem;
}

.top-8 {
  top: 2rem;
}

.top-80 {
  top: 20rem;
}

.top-96 {
  top: 24rem;
}

.top-\\[10\\%\\] {
  top: 10%;
}

.top-\\[12px\\] {
  top: 12px;
}

.top-\\[140px\\] {
  top: 140px;
}

.top-\\[15\\.5\\%\\] {
  top: 15.5%;
}

.top-\\[5\\%\\] {
  top: 5%;
}

.top-\\[64px\\] {
  top: 64px;
}

.top-\\[70\\%\\] {
  top: 70%;
}

.top-\\[80px\\] {
  top: 80px;
}

.top-full {
  top: 100%;
}

.top-\\[var\\(--topbar-height\\2c 60px\\)\\] {
  top: var(--topbar-height,60px);
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-30 {
  z-index: 30;
}

.z-40 {
  z-index: 40;
}

.z-50 {
  z-index: 50;
}

.z-\\[10000\\] {
  z-index: 10000;
}

.z-\\[10001\\] {
  z-index: 10001;
}

.z-\\[1000\\] {
  z-index: 1000;
}

.z-\\[100\\] {
  z-index: 100;
}

.z-\\[60\\] {
  z-index: 60;
}

.z-\\[99999\\] {
  z-index: 99999;
}

.z-\\[9999\\] {
  z-index: 9999;
}

.z-\\[999\\] {
  z-index: 999;
}

.z-\\[99\\] {
  z-index: 99;
}

.z-\\[9\\] {
  z-index: 9;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.col-span-12 {
  grid-column: span 12 / span 12;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.col-span-4 {
  grid-column: span 4 / span 4;
}

.col-span-7 {
  grid-column: span 7 / span 7;
}

.m-0 {
  margin: 0px;
}

.m-0\\.5 {
  margin: 0.125rem;
}

.m-1 {
  margin: 0.25rem;
}

.m-10 {
  margin: 2.5rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-3 {
  margin: 0.75rem;
}

.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}

.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-\\[6px\\] {
  margin-top: 6px;
  margin-bottom: 6px;
}

.-mb-6 {
  margin-bottom: -1.5rem;
}

.-mt-2 {
  margin-top: -0.5rem;
}

.-mt-36 {
  margin-top: -9rem;
}

.-mt-4 {
  margin-top: -1rem;
}

.-mt-96 {
  margin-top: -24rem;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-0\\.5 {
  margin-bottom: 0.125rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mb-12 {
  margin-bottom: 3rem;
}

.mb-14 {
  margin-bottom: 3.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.ml-0 {
  margin-left: 0px;
}

.ml-0\\.5 {
  margin-left: 0.125rem;
}

.ml-1 {
  margin-left: 0.25rem;
}

.ml-1\\.5 {
  margin-left: 0.375rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.ml-4 {
  margin-left: 1rem;
}

.ml-6 {
  margin-left: 1.5rem;
}

.ml-7 {
  margin-left: 1.75rem;
}

.ml-8 {
  margin-left: 2rem;
}

.ml-\\[22rem\\] {
  margin-left: 22rem;
}

.ml-auto {
  margin-left: auto;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mr-12 {
  margin-right: 3rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mr-5 {
  margin-right: 1.25rem;
}

.mr-8 {
  margin-right: 2rem;
}

.mt-0 {
  margin-top: 0px;
}

.mt-0\\.5 {
  margin-top: 0.125rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-2\\.5 {
  margin-top: 0.625rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-\\[100px\\] {
  margin-top: 100px;
}

.mt-\\[12\\%\\] {
  margin-top: 12%;
}

.mt-\\[18px\\] {
  margin-top: 18px;
}

.mt-\\[3px\\] {
  margin-top: 3px;
}

.mt-\\[5\\%\\] {
  margin-top: 5%;
}

.mt-\\[60px\\] {
  margin-top: 60px;
}

.mt-\\[6px\\] {
  margin-top: 6px;
}

.mt-auto {
  margin-top: auto;
}

.box-border {
  box-sizing: border-box;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.contents {
  display: contents;
}

.hidden {
  display: none;
}

.aspect-square {
  aspect-ratio: 1 / 1;
}

.aspect-video {
  aspect-ratio: 16 / 9;
}

.\\!h-\\[15vh\\] {
  height: 15vh !important;
}

.\\!h-\\[50vh\\] {
  height: 50vh !important;
}

.\\!h-\\[89vh\\] {
  height: 89vh !important;
}

.\\!h-\\[91\\.7vh\\] {
  height: 91.7vh !important;
}

.h-0 {
  height: 0px;
}

.h-0\\.5 {
  height: 0.125rem;
}

.h-1 {
  height: 0.25rem;
}

.h-1\\.5 {
  height: 0.375rem;
}

.h-10 {
  height: 2.5rem;
}

.h-11 {
  height: 2.75rem;
}

.h-12 {
  height: 3rem;
}

.h-14 {
  height: 3.5rem;
}

.h-16 {
  height: 4rem;
}

.h-2 {
  height: 0.5rem;
}

.h-2\\.5 {
  height: 0.625rem;
}

.h-20 {
  height: 5rem;
}

.h-24 {
  height: 6rem;
}

.h-28 {
  height: 7rem;
}

.h-3 {
  height: 0.75rem;
}

.h-3\\.5 {
  height: 0.875rem;
}

.h-32 {
  height: 8rem;
}

.h-36 {
  height: 9rem;
}

.h-4 {
  height: 1rem;
}

.h-40 {
  height: 10rem;
}

.h-48 {
  height: 12rem;
}

.h-5 {
  height: 1.25rem;
}

.h-6 {
  height: 1.5rem;
}

.h-64 {
  height: 16rem;
}

.h-7 {
  height: 1.75rem;
}

.h-8 {
  height: 2rem;
}

.h-9 {
  height: 2.25rem;
}

.h-\\[100px\\] {
  height: 100px;
}

.h-\\[100vh\\] {
  height: 100vh;
}

.h-\\[120px\\] {
  height: 120px;
}

.h-\\[150px\\] {
  height: 150px;
}

.h-\\[19px\\] {
  height: 19px;
}

.h-\\[1px\\] {
  height: 1px;
}

.h-\\[200px\\] {
  height: 200px;
}

.h-\\[22px\\] {
  height: 22px;
}

.h-\\[259px\\] {
  height: 259px;
}

.h-\\[27\\.96px\\] {
  height: 27.96px;
}

.h-\\[300px\\] {
  height: 300px;
}

.h-\\[30px\\] {
  height: 30px;
}

.h-\\[32px\\] {
  height: 32px;
}

.h-\\[34px\\] {
  height: 34px;
}

.h-\\[350px\\] {
  height: 350px;
}

.h-\\[40\\.97px\\] {
  height: 40.97px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-\\[52px\\] {
  height: 52px;
}

.h-\\[60px\\] {
  height: 60px;
}

.h-\\[60vh\\] {
  height: 60vh;
}

.h-\\[70px\\] {
  height: 70px;
}

.h-\\[75px\\] {
  height: 75px;
}

.h-\\[76px\\] {
  height: 76px;
}

.h-\\[7px\\] {
  height: 7px;
}

.h-\\[80px\\] {
  height: 80px;
}

.h-\\[90px\\] {
  height: 90px;
}

.h-\\[90vh\\] {
  height: 90vh;
}

.h-\\[calc\\(100\\%-4rem\\)\\] {
  height: calc(100% - 4rem);
}

.h-\\[calc\\(100vh-100px\\)\\] {
  height: calc(100vh - 100px);
}

.h-\\[calc\\(100vh-100px-60px\\)\\] {
  height: calc(100vh - 100px - 60px);
}

.h-\\[calc\\(100vh-130px\\)\\] {
  height: calc(100vh - 130px);
}

.h-\\[calc\\(100vh-4rem\\)\\] {
  height: calc(100vh - 4rem);
}

.h-\\[calc\\(100vh-4rem-5rem\\)\\] {
  height: calc(100vh - 4rem - 5rem);
}

.h-auto {
  height: auto;
}

.h-fit {
  height: fit-content;
}

.h-full {
  height: 100%;
}

.h-px {
  height: 1px;
}

.h-screen {
  height: 100vh;
}

.\\!h-\\[calc\\(100vh-var\\(--topbar-height\\2c 64px\\)-60px\\)\\] {
  height: calc(100vh - var(--topbar-height,64px) - 60px) !important;
}

.max-h-0 {
  max-height: 0px;
}

.max-h-28 {
  max-height: 7rem;
}

.max-h-40 {
  max-height: 10rem;
}

.max-h-44 {
  max-height: 11rem;
}

.max-h-48 {
  max-height: 12rem;
}

.max-h-60 {
  max-height: 15rem;
}

.max-h-80 {
  max-height: 20rem;
}

.max-h-\\[1200px\\] {
  max-height: 1200px;
}

.max-h-\\[200px\\] {
  max-height: 200px;
}

.max-h-\\[300px\\] {
  max-height: 300px;
}

.max-h-\\[40vh\\] {
  max-height: 40vh;
}

.max-h-\\[600px\\] {
  max-height: 600px;
}

.max-h-\\[60vh\\] {
  max-height: 60vh;
}

.max-h-\\[70vh\\] {
  max-height: 70vh;
}

.max-h-\\[80vh\\] {
  max-height: 80vh;
}

.max-h-\\[90vh\\] {
  max-height: 90vh;
}

.max-h-\\[95vh\\] {
  max-height: 95vh;
}

.max-h-\\[calc\\(100vh-120px\\)\\] {
  max-height: calc(100vh - 120px);
}

.max-h-\\[calc\\(100vh-180px\\)\\] {
  max-height: calc(100vh - 180px);
}

.max-h-full {
  max-height: 100%;
}

.max-h-screen {
  max-height: 100vh;
}

.max-h-\\[30vh\\] {
  max-height: 30vh;
}

.max-h-\\[50vh\\] {
  max-height: 50vh;
}

.min-h-0 {
  min-height: 0px;
}

.min-h-48 {
  min-height: 12rem;
}

.min-h-96 {
  min-height: 24rem;
}

.min-h-\\[100px\\] {
  min-height: 100px;
}

.min-h-\\[200px\\] {
  min-height: 200px;
}

.min-h-\\[283px\\] {
  min-height: 283px;
}

.min-h-\\[300px\\] {
  min-height: 300px;
}

.min-h-\\[36px\\] {
  min-height: 36px;
}

.min-h-\\[400px\\] {
  min-height: 400px;
}

.min-h-\\[44px\\] {
  min-height: 44px;
}

.min-h-\\[48px\\] {
  min-height: 48px;
}

.min-h-\\[60px\\] {
  min-height: 60px;
}

.min-h-\\[90px\\] {
  min-height: 90px;
}

.min-h-\\[calc\\(100vh-80px\\)\\] {
  min-height: calc(100vh - 80px);
}

.min-h-full {
  min-height: 100%;
}

.min-h-screen {
  min-height: 100vh;
}

.w-0 {
  width: 0px;
}

.w-0\\.5 {
  width: 0.125rem;
}

.w-1 {
  width: 0.25rem;
}

.w-1\\.5 {
  width: 0.375rem;
}

.w-1\\/2 {
  width: 50%;
}

.w-1\\/3 {
  width: 33.333333%;
}

.w-1\\/4 {
  width: 25%;
}

.w-1\\/5 {
  width: 20%;
}

.w-1\\/6 {
  width: 16.666667%;
}

.w-10 {
  width: 2.5rem;
}

.w-11 {
  width: 2.75rem;
}

.w-11\\/12 {
  width: 91.666667%;
}

.w-12 {
  width: 3rem;
}

.w-14 {
  width: 3.5rem;
}

.w-16 {
  width: 4rem;
}

.w-2 {
  width: 0.5rem;
}

.w-2\\.5 {
  width: 0.625rem;
}

.w-2\\/3 {
  width: 66.666667%;
}

.w-20 {
  width: 5rem;
}

.w-24 {
  width: 6rem;
}

.w-28 {
  width: 7rem;
}

.w-3 {
  width: 0.75rem;
}

.w-3\\.5 {
  width: 0.875rem;
}

.w-3\\/4 {
  width: 75%;
}

.w-32 {
  width: 8rem;
}

.w-36 {
  width: 9rem;
}

.w-4 {
  width: 1rem;
}

.w-4\\/6 {
  width: 66.666667%;
}

.w-40 {
  width: 10rem;
}

.w-44 {
  width: 11rem;
}

.w-48 {
  width: 12rem;
}

.w-5 {
  width: 1.25rem;
}

.w-52 {
  width: 13rem;
}

.w-56 {
  width: 14rem;
}

.w-6 {
  width: 1.5rem;
}

.w-60 {
  width: 15rem;
}

.w-64 {
  width: 16rem;
}

.w-7 {
  width: 1.75rem;
}

.w-72 {
  width: 18rem;
}

.w-8 {
  width: 2rem;
}

.w-80 {
  width: 20rem;
}

.w-9 {
  width: 2.25rem;
}

.w-96 {
  width: 24rem;
}

.w-\\[104px\\] {
  width: 104px;
}

.w-\\[120px\\] {
  width: 120px;
}

.w-\\[140px\\] {
  width: 140px;
}

.w-\\[160px\\] {
  width: 160px;
}

.w-\\[180px\\] {
  width: 180px;
}

.w-\\[200px\\] {
  width: 200px;
}

.w-\\[22px\\] {
  width: 22px;
}

.w-\\[28\\.18px\\] {
  width: 28.18px;
}

.w-\\[33px\\] {
  width: 33px;
}

.w-\\[340px\\] {
  width: 340px;
}

.w-\\[34px\\] {
  width: 34px;
}

.w-\\[350px\\] {
  width: 350px;
}

.w-\\[35px\\] {
  width: 35px;
}

.w-\\[50px\\] {
  width: 50px;
}

.w-\\[52px\\] {
  width: 52px;
}

.w-\\[55px\\] {
  width: 55px;
}

.w-\\[60px\\] {
  width: 60px;
}

.w-\\[70px\\] {
  width: 70px;
}

.w-\\[80px\\] {
  width: 80px;
}

.w-\\[83px\\] {
  width: 83px;
}

.w-\\[85px\\] {
  width: 85px;
}

.w-\\[98\\%\\] {
  width: 98%;
}

.w-auto {
  width: auto;
}

.w-fit {
  width: fit-content;
}

.w-full {
  width: 100%;
}

.w-px {
  width: 1px;
}

.w-screen {
  width: 100vw;
}

.w-\\[85\\%\\] {
  width: 85%;
}

.min-w-0 {
  min-width: 0px;
}

.min-w-52 {
  min-width: 13rem;
}

.min-w-\\[100px\\] {
  min-width: 100px;
}

.min-w-\\[110px\\] {
  min-width: 110px;
}

.min-w-\\[120px\\] {
  min-width: 120px;
}

.min-w-\\[140px\\] {
  min-width: 140px;
}

.min-w-\\[14px\\] {
  min-width: 14px;
}

.min-w-\\[150px\\] {
  min-width: 150px;
}

.min-w-\\[180px\\] {
  min-width: 180px;
}

.min-w-\\[200px\\] {
  min-width: 200px;
}

.min-w-\\[320px\\] {
  min-width: 320px;
}

.min-w-\\[45px\\] {
  min-width: 45px;
}

.min-w-\\[60px\\] {
  min-width: 60px;
}

.min-w-fit {
  min-width: fit-content;
}

.min-w-\\[280px\\] {
  min-width: 280px;
}

.max-w-2xl {
  max-width: 42rem;
}

.max-w-3xl {
  max-width: 48rem;
}

.max-w-4xl {
  max-width: 56rem;
}

.max-w-5xl {
  max-width: 64rem;
}

.max-w-6xl {
  max-width: 72rem;
}

.max-w-7xl {
  max-width: 80rem;
}

.max-w-\\[100px\\] {
  max-width: 100px;
}

.max-w-\\[120px\\] {
  max-width: 120px;
}

.max-w-\\[158px\\] {
  max-width: 158px;
}

.max-w-\\[160px\\] {
  max-width: 160px;
}

.max-w-\\[240px\\] {
  max-width: 240px;
}

.max-w-\\[280px\\] {
  max-width: 280px;
}

.max-w-\\[314px\\] {
  max-width: 314px;
}

.max-w-\\[320px\\] {
  max-width: 320px;
}

.max-w-\\[348px\\] {
  max-width: 348px;
}

.max-w-\\[393px\\] {
  max-width: 393px;
}

.max-w-\\[400px\\] {
  max-width: 400px;
}

.max-w-\\[403px\\] {
  max-width: 403px;
}

.max-w-\\[40vw\\] {
  max-width: 40vw;
}

.max-w-\\[420px\\] {
  max-width: 420px;
}

.max-w-\\[500px\\] {
  max-width: 500px;
}

.max-w-\\[508px\\] {
  max-width: 508px;
}

.max-w-\\[531px\\] {
  max-width: 531px;
}

.max-w-\\[538px\\] {
  max-width: 538px;
}

.max-w-\\[632px\\] {
  max-width: 632px;
}

.max-w-\\[932px\\] {
  max-width: 932px;
}

.max-w-full {
  max-width: 100%;
}

.max-w-lg {
  max-width: 32rem;
}

.max-w-md {
  max-width: 28rem;
}

.max-w-none {
  max-width: none;
}

.max-w-sm {
  max-width: 24rem;
}

.max-w-xl {
  max-width: 36rem;
}

.max-w-xs {
  max-width: 20rem;
}

.max-w-\\[40\\%\\] {
  max-width: 40%;
}

.flex-1 {
  flex: 1 1;
}

.flex-\\[3\\] {
  flex: 3 1;
}

.flex-none {
  flex: none;
}

.flex-\\[2\\] {
  flex: 2 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.basis-1\\/2 {
  flex-basis: 50%;
}

.basis-1\\/6 {
  flex-basis: 16.666667%;
}

.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-2 {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-12 {
  --tw-translate-x: 3rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-6 {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-8 {
  --tw-translate-x: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[1\\.4rem\\] {
  --tw-translate-x: 1.4rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[15px\\] {
  --tw-translate-x: 15px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.cursor-crosshair {
  cursor: crosshair;
}

.cursor-default {
  cursor: default;
}

.cursor-ew-resize {
  cursor: ew-resize;
}

.cursor-grab {
  cursor: grab;
}

.cursor-grabbing {
  cursor: grabbing;
}

.cursor-help {
  cursor: help;
}

.cursor-move {
  cursor: move;
}

.cursor-ne-resize {
  cursor: ne-resize;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-ns-resize {
  cursor: ns-resize;
}

.cursor-nw-resize {
  cursor: nw-resize;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-se-resize {
  cursor: se-resize;
}

.cursor-sw-resize {
  cursor: sw-resize;
}

.touch-none {
  touch-action: none;
}

.touch-manipulation {
  touch-action: manipulation;
}

.select-none {
  -webkit-user-select: none;
          user-select: none;
}

.resize-none {
  resize: none;
}

.resize {
  resize: both;
}

.list-disc {
  list-style-type: disc;
}

.appearance-none {
  appearance: none;
}

.auto-cols-max {
  grid-auto-columns: max-content;
}

.grid-flow-row {
  grid-auto-flow: row;
}

.grid-flow-col {
  grid-auto-flow: column;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.gap-0 {
  gap: 0px;
}

.gap-0\\.5 {
  gap: 0.125rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-1\\.5 {
  gap: 0.375rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-11 {
  gap: 2.75rem;
}

.gap-12 {
  gap: 3rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-2\\.5 {
  gap: 0.625rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-8 {
  gap: 2rem;
}

.gap-9 {
  gap: 2.25rem;
}

.gap-\\[2px\\] {
  gap: 2px;
}

.gap-\\[54px\\] {
  gap: 54px;
}

.gap-px {
  gap: 1px;
}

.gap-x-2 {
  column-gap: 0.5rem;
}

.gap-y-2 {
  row-gap: 0.5rem;
}

.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}

.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}

.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}

.divide-\\[\\#3F4346\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(63 67 70 / var(--tw-divide-opacity, 1));
}

.self-start {
  align-self: flex-start;
}

.self-stretch {
  align-self: stretch;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.overflow-ellipsis {
  text-overflow: ellipsis;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.whitespace-pre-line {
  white-space: pre-line;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

.text-nowrap {
  text-wrap: nowrap;
}

.break-words {
  overflow-wrap: break-word;
}

.break-all {
  word-break: break-all;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-\\[10px\\] {
  border-radius: 10px;
}

.rounded-\\[11\\.5px\\] {
  border-radius: 11.5px;
}

.rounded-\\[11px\\] {
  border-radius: 11px;
}

.rounded-\\[20px\\] {
  border-radius: 20px;
}

.rounded-\\[33px\\] {
  border-radius: 33px;
}

.rounded-\\[5px\\] {
  border-radius: 5px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-none {
  border-radius: 0px;
}

.rounded-sm {
  border-radius: 0.125rem;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.rounded-b-full {
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.\\!border {
  border-width: 1px !important;
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-\\[0\\.5px\\] {
  border-width: 0.5px;
}

.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-l {
  border-left-width: 1px;
}

.border-t {
  border-top-width: 1px;
}

.border-t-2 {
  border-top-width: 2px;
}

.border-solid {
  border-style: solid;
}

.border-dashed {
  border-style: dashed;
}

.border-none {
  border-style: none;
}

.\\!border-\\[\\#615fff\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(97 95 255 / var(--tw-border-opacity, 1)) !important;
}

.\\!border-\\[\\#6A1FBF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(106 31 191 / var(--tw-border-opacity, 1)) !important;
}

.border-\\[\\#00C853\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 200 83 / var(--tw-border-opacity, 1));
}

.border-\\[\\#1CD760\\] {
  --tw-border-opacity: 1;
  border-color: rgb(28 215 96 / var(--tw-border-opacity, 1));
}

.border-\\[\\#2B2A3C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(43 42 60 / var(--tw-border-opacity, 1));
}

.border-\\[\\#2F2E4E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(47 46 78 / var(--tw-border-opacity, 1));
}

.border-\\[\\#39364A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(57 54 74 / var(--tw-border-opacity, 1));
}

.border-\\[\\#3F4346\\] {
  --tw-border-opacity: 1;
  border-color: rgb(63 67 70 / var(--tw-border-opacity, 1));
}

.border-\\[\\#462091\\] {
  --tw-border-opacity: 1;
  border-color: rgb(70 32 145 / var(--tw-border-opacity, 1));
}

.border-\\[\\#615B72\\] {
  --tw-border-opacity: 1;
  border-color: rgb(97 91 114 / var(--tw-border-opacity, 1));
}

.border-\\[\\#6A1FBF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(106 31 191 / var(--tw-border-opacity, 1));
}

.border-\\[\\#7700ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(119 0 255 / var(--tw-border-opacity, 1));
}

.border-\\[\\#7700ff\\]\\/20 {
  border-color: rgb(119 0 255 / 0.2);
}

.border-\\[\\#8e01da\\] {
  --tw-border-opacity: 1;
  border-color: rgb(142 1 218 / var(--tw-border-opacity, 1));
}

.border-\\[\\#9B9B9B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(155 155 155 / var(--tw-border-opacity, 1));
}

.border-\\[\\#D3D3E0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(211 211 224 / var(--tw-border-opacity, 1));
}

.border-\\[\\#DCDFE3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 223 227 / var(--tw-border-opacity, 1));
}

.border-\\[\\#F4C2D7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244 194 215 / var(--tw-border-opacity, 1));
}

.border-\\[\\#FF0013\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 0 19 / var(--tw-border-opacity, 1));
}

.border-\\[\\#ffffff33\\] {
  border-color: #ffffff33;
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.border-blue-500\\/30 {
  border-color: rgb(59 130 246 / 0.3);
}

.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(218 218 218 / var(--tw-border-opacity, 1));
}

.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(129 129 129 / var(--tw-border-opacity, 1));
}

.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(85 85 85 / var(--tw-border-opacity, 1));
}

.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(111 118 126 / var(--tw-border-opacity, 1));
}

.border-gray-500\\/30 {
  border-color: rgb(111 118 126 / 0.3);
}

.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(64 75 83 / var(--tw-border-opacity, 1));
}

.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(35 40 48 / var(--tw-border-opacity, 1));
}

.border-gray-700\\/50 {
  border-color: rgb(35 40 48 / 0.5);
}

.border-gray-700\\/60 {
  border-color: rgb(35 40 48 / 0.6);
}

.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(5 10 14 / var(--tw-border-opacity, 1));
}

.border-gray-850 {
  --tw-border-opacity: 1;
  border-color: rgb(38 40 44 / var(--tw-border-opacity, 1));
}

.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}

.border-green-500\\/30 {
  border-color: rgb(34 197 94 / 0.3);
}

.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.border-red-150 {
  --tw-border-opacity: 1;
  border-color: rgb(211 47 47 / var(--tw-border-opacity, 1));
}

.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}

.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}

.border-red-500\\/50 {
  border-color: rgb(239 68 68 / 0.5);
}

.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}

.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}

.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}

.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}

.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
}

.border-blue-500\\/20 {
  border-color: rgb(59 130 246 / 0.2);
}

.border-r-\\[\\#7700ff\\] {
  --tw-border-opacity: 1;
  border-right-color: rgb(119 0 255 / var(--tw-border-opacity, 1));
}

.border-t-\\[\\#7700ff\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(119 0 255 / var(--tw-border-opacity, 1));
}

.bg-\\[\\#00000014\\] {
  background-color: #00000014;
}

.bg-\\[\\#0000001F\\] {
  background-color: #0000001F;
}

.bg-\\[\\#00000026\\] {
  background-color: #00000026;
}

.bg-\\[\\#00000038\\] {
  background-color: #00000038;
}

.bg-\\[\\#00000070\\] {
  background-color: #00000070;
}

.bg-\\[\\#00000080\\] {
  background-color: #00000080;
}

.bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#000000\\]\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}

.bg-\\[\\#0000\\] {
  background-color: #0000;
}

.bg-\\[\\#00C853\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 200 83 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#020617\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#060621\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(6 6 33 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#0a0a1f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 31 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#0f0f1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 15 30 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#14B14B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 177 75 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#181c1f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(24 28 31 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#1C1B29\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 27 41 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#1C1F2E\\]\\/95 {
  background-color: rgb(28 31 46 / 0.95);
}

.bg-\\[\\#1CD760\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 215 96 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#1F1F25\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 37 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#1a1a2e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 46 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#1c1c1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 30 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#231E1F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 30 31 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#232323\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 35 35 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#23272b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 39 43 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#242626\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 38 38 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#28242E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 36 46 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#282828\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 40 40 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#2A2835\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(42 40 53 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#360083\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(54 0 131 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#3A285F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(58 40 95 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#462091\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(70 32 145 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#4C4563\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(76 69 99 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#4a5568\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(74 85 104 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#565167\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(86 81 103 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#5E5D60\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(94 93 96 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#615B72\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(97 91 114 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#6A1FBF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(106 31 191 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#6A1FBF\\]\\/20 {
  background-color: rgb(106 31 191 / 0.2);
}

.bg-\\[\\#6F00F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(111 0 246 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#6F5CA4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(111 92 164 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#6F767E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(111 118 126 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#7700FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(119 0 255 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#7700FF\\]\\/20 {
  background-color: rgb(119 0 255 / 0.2);
}

.bg-\\[\\#7700ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(119 0 255 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#7700ff\\]\\/10 {
  background-color: rgb(119 0 255 / 0.1);
}

.bg-\\[\\#7700ff\\]\\/20 {
  background-color: rgb(119 0 255 / 0.2);
}

.bg-\\[\\#785E82\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(120 94 130 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#7F7F7F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(127 127 127 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#7c3aed\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#800080\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(128 0 128 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#818181\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(129 129 129 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#832CFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(131 44 255 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#898989\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(137 137 137 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#8A2BE2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(138 43 226 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#8B5CF6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#9492AD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(148 146 173 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#FFE5EE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 229 238 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#dc2626\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.bg-\\[\\#ffffff1f\\] {
  background-color: #ffffff1f;
}

.bg-\\[\\#ffffff4b\\] {
  background-color: #ffffff4b;
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.bg-black\\/15 {
  background-color: rgb(0 0 0 / 0.15);
}

.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}

.bg-black\\/25 {
  background-color: rgb(0 0 0 / 0.25);
}

.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}

.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}

.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}

.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}

.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}

.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}

.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}

.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}

.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.bg-customGray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(40 40 40 / var(--tw-bg-opacity, 1));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.bg-gray-150 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 64 70 / var(--tw-bg-opacity, 1));
}

.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity, 1));
}

.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(218 218 218 / var(--tw-bg-opacity, 1));
}

.bg-gray-350 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 65 84 / var(--tw-bg-opacity, 1));
}

.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 129 129 / var(--tw-bg-opacity, 1));
}

.bg-gray-450 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 90 100 / var(--tw-bg-opacity, 1));
}

.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(85 85 85 / var(--tw-bg-opacity, 1));
}

.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(111 118 126 / var(--tw-bg-opacity, 1));
}

.bg-gray-500\\/20 {
  background-color: rgb(111 118 126 / 0.2);
}

.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(64 75 83 / var(--tw-bg-opacity, 1));
}

.bg-gray-650 {
  --tw-bg-opacity: 1;
  background-color: rgb(32 36 39 / var(--tw-bg-opacity, 1));
}

.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(35 40 48 / var(--tw-bg-opacity, 1));
}

.bg-gray-700\\/30 {
  background-color: rgb(35 40 48 / 0.3);
}

.bg-gray-700\\/50 {
  background-color: rgb(35 40 48 / 0.5);
}

.bg-gray-700\\/60 {
  background-color: rgb(35 40 48 / 0.6);
}

.bg-gray-700\\/80 {
  background-color: rgb(35 40 48 / 0.8);
}

.bg-gray-700\\/90 {
  background-color: rgb(35 40 48 / 0.9);
}

.bg-gray-750 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 28 34 / var(--tw-bg-opacity, 1));
}

.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 10 14 / var(--tw-bg-opacity, 1));
}

.bg-gray-800\\/30 {
  background-color: rgb(5 10 14 / 0.3);
}

.bg-gray-800\\/50 {
  background-color: rgb(5 10 14 / 0.5);
}

.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(149 149 158 / var(--tw-bg-opacity, 1));
}

.bg-gray-900\\/90 {
  background-color: rgb(149 149 158 / 0.9);
}

.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.bg-green-500\\/20 {
  background-color: rgb(34 197 94 / 0.2);
}

.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.bg-indigo-500\\/20 {
  background-color: rgb(99 102 241 / 0.2);
}

.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}

.bg-primaryDarkBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(6 6 33 / var(--tw-bg-opacity, 1));
}

.bg-primaryPurple {
  --tw-bg-opacity: 1;
  background-color: rgb(119 0 255 / var(--tw-bg-opacity, 1));
}

.bg-purple-350 {
  --tw-bg-opacity: 1;
  background-color: rgb(85 104 254 / var(--tw-bg-opacity, 1));
}

.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 111 234 / var(--tw-bg-opacity, 1));
}

.bg-purple-750 {
  --tw-bg-opacity: 1;
  background-color: rgb(98 70 251 / var(--tw-bg-opacity, 1));
}

.bg-red-150 {
  --tw-bg-opacity: 1;
  background-color: rgb(211 47 47 / var(--tw-bg-opacity, 1));
}

.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}

.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}

.bg-red-500\\/20 {
  background-color: rgb(239 68 68 / 0.2);
}

.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.bg-red-650 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 93 93 / var(--tw-bg-opacity, 1));
}

.bg-red-900\\/30 {
  background-color: rgb(127 29 29 / 0.3);
}

.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}

.bg-slate-900\\/95 {
  background-color: rgb(15 23 42 / 0.95);
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}

.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}

.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}

.bg-\\[\\#5A4A6B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(90 74 107 / var(--tw-bg-opacity, 1));
}

.bg-gray-800\\/90 {
  background-color: rgb(5 10 14 / 0.9);
}

.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}

.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}

.bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}

.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}

.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}

.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}

.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}

.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}

.bg-\\[linear-gradient\\(to_top\\2c _\\#38275B_0\\%\\2c _\\#251A3C_33\\.33333333333333\\%\\2c _\\#140E20_66\\.66666666666666\\%\\2c _\\#000000_100\\%\\)\\] {
  background-image: linear-gradient(to top, #38275B 0%, #251A3C 33.33333333333333%, #140E20 66.66666666666666%, #000000 100%);
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.from-\\[\\#000000\\] {
  --tw-gradient-from: #000000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-black\\/70 {
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-gray-800\\/20 {
  --tw-gradient-from: rgb(5 10 14 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 10 14 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-gray-900 {
  --tw-gradient-from: #95959E var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(149 149 158 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-purple-600 {
  --tw-gradient-from: #586FEA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 111 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-red-500 {
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-black\\/90 {
  --tw-gradient-from: rgb(0 0 0 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.via-gray-800 {
  --tw-gradient-to: rgb(5 10 14 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #050A0E var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.via-black\\/70 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.to-\\[\\#3A285E\\] {
  --tw-gradient-to: #3A285E var(--tw-gradient-to-position);
}

.to-blue-900\\/20 {
  --tw-gradient-to: rgb(30 58 138 / 0.2) var(--tw-gradient-to-position);
}

.to-gray-900 {
  --tw-gradient-to: #95959E var(--tw-gradient-to-position);
}

.to-gray-900\\/20 {
  --tw-gradient-to: rgb(149 149 158 / 0.2) var(--tw-gradient-to-position);
}

.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}

.to-purple-700 {
  --tw-gradient-to: #4F63D2 var(--tw-gradient-to-position);
}

.bg-cover {
  background-size: cover;
}

.bg-center {
  background-position: center;
}

.bg-no-repeat {
  background-repeat: no-repeat;
}

.object-contain {
  object-fit: contain;
}

.object-cover {
  object-fit: cover;
}

.p-0 {
  padding: 0px;
}

.p-0\\.5 {
  padding: 0.125rem;
}

.p-1 {
  padding: 0.25rem;
}

.p-1\\.5 {
  padding: 0.375rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-2\\.5 {
  padding: 0.625rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-\\[5px\\] {
  padding: 5px;
}

.p-\\[9px\\] {
  padding: 9px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.px-11 {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}

.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-11 {
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}

.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.py-9 {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.pb-0 {
  padding-bottom: 0px;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pb-16 {
  padding-bottom: 4rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pb-24 {
  padding-bottom: 6rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pb-8 {
  padding-bottom: 2rem;
}

.pl-0 {
  padding-left: 0px;
}

.pl-1 {
  padding-left: 0.25rem;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pl-12 {
  padding-left: 3rem;
}

.pl-14 {
  padding-left: 3.5rem;
}

.pl-2 {
  padding-left: 0.5rem;
}

.pl-3 {
  padding-left: 0.75rem;
}

.pl-4 {
  padding-left: 1rem;
}

.pl-5 {
  padding-left: 1.25rem;
}

.pl-6 {
  padding-left: 1.5rem;
}

.pl-7 {
  padding-left: 1.75rem;
}

.pl-8 {
  padding-left: 2rem;
}

.pl-9 {
  padding-left: 2.25rem;
}

.pr-1 {
  padding-right: 0.25rem;
}

.pr-12 {
  padding-right: 3rem;
}

.pr-2 {
  padding-right: 0.5rem;
}

.pr-20 {
  padding-right: 5rem;
}

.pr-3 {
  padding-right: 0.75rem;
}

.pr-4 {
  padding-right: 1rem;
}

.pr-5 {
  padding-right: 1.25rem;
}

.pr-8 {
  padding-right: 2rem;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pt-16 {
  padding-top: 4rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-24 {
  padding-top: 6rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pt-8 {
  padding-top: 2rem;
}

.pt-\\[1\\%\\] {
  padding-top: 1%;
}

.pt-\\[1px\\] {
  padding-top: 1px;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-start {
  text-align: start;
}

.align-middle {
  vertical-align: middle;
}

.font-bebas {
  font-family: Bebas Neue, cursive;
}

.font-mono {
  font-family: Source Code Pro, Menlo, monospace;
}

.font-montserrat {
  font-family: Montserrat, sans-serif;
}

.font-poppins {
  font-family: Poppins, sans-serif;
}

.font-sans {
  font-family: Montserrat, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-\\[10px\\] {
  font-size: 10px;
}

.text-\\[12px\\] {
  font-size: 12px;
}

.text-\\[13px\\] {
  font-size: 13px;
}

.text-\\[15px\\] {
  font-size: 15px;
}

.text-\\[16px\\] {
  font-size: 16px;
}

.text-\\[17px\\] {
  font-size: 17px;
}

.text-\\[23px\\] {
  font-size: 23px;
}

.text-\\[28px\\] {
  font-size: 28px;
}

.text-\\[33px\\] {
  font-size: 33px;
}

.text-\\[7px\\] {
  font-size: 7px;
}

.text-\\[8px\\] {
  font-size: 8px;
}

.text-\\[9px\\] {
  font-size: 9px;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold {
  font-weight: 700;
}

.font-extrabold {
  font-weight: 800;
}

.font-light {
  font-weight: 300;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.italic {
  font-style: italic;
}

.not-italic {
  font-style: normal;
}

.leading-4 {
  line-height: 1rem;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-6 {
  line-height: 1.5rem;
}

.leading-\\[10px\\] {
  line-height: 10px;
}

.leading-\\[14px\\] {
  line-height: 14px;
}

.leading-\\[22px\\] {
  line-height: 22px;
}

.leading-\\[30px\\] {
  line-height: 30px;
}

.leading-none {
  line-height: 1;
}

.leading-normal {
  line-height: 1.5;
}

.leading-relaxed {
  line-height: 1.625;
}

.leading-snug {
  line-height: 1.375;
}

.leading-tight {
  line-height: 1.25;
}

.tracking-\\[-0\\.03em\\] {
  letter-spacing: -0.03em;
}

.tracking-\\[-0\\.12px\\] {
  letter-spacing: -0.12px;
}

.tracking-\\[-0\\.15px\\] {
  letter-spacing: -0.15px;
}

.tracking-\\[-0\\.18px\\] {
  letter-spacing: -0.18px;
}

.tracking-\\[0\\.17px\\] {
  letter-spacing: 0.17px;
}

.tracking-\\[0\\.24px\\] {
  letter-spacing: 0.24px;
}

.tracking-\\[0\\.25px\\] {
  letter-spacing: 0.25px;
}

.tracking-\\[0\\.2px\\] {
  letter-spacing: 0.2px;
}

.tracking-\\[0\\.34px\\] {
  letter-spacing: 0.34px;
}

.tracking-\\[3px\\] {
  letter-spacing: 3px;
}

.tracking-\\[5px\\] {
  letter-spacing: 5px;
}

.tracking-normal {
  letter-spacing: 0em;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.tracking-wide {
  letter-spacing: 0.025em;
}

.tracking-wider {
  letter-spacing: 0.05em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.text-\\[\\#00C853\\] {
  --tw-text-opacity: 1;
  color: rgb(0 200 83 / var(--tw-text-opacity, 1));
}

.text-\\[\\#1CD760\\] {
  --tw-text-opacity: 1;
  color: rgb(28 215 96 / var(--tw-text-opacity, 1));
}

.text-\\[\\#1c1f2e\\] {
  --tw-text-opacity: 1;
  color: rgb(28 31 46 / var(--tw-text-opacity, 1));
}

.text-\\[\\#4b59c9\\] {
  --tw-text-opacity: 1;
  color: rgb(75 89 201 / var(--tw-text-opacity, 1));
}

.text-\\[\\#606060\\] {
  --tw-text-opacity: 1;
  color: rgb(96 96 96 / var(--tw-text-opacity, 1));
}

.text-\\[\\#747B84\\] {
  --tw-text-opacity: 1;
  color: rgb(116 123 132 / var(--tw-text-opacity, 1));
}

.text-\\[\\#758195\\] {
  --tw-text-opacity: 1;
  color: rgb(117 129 149 / var(--tw-text-opacity, 1));
}

.text-\\[\\#7700FF\\] {
  --tw-text-opacity: 1;
  color: rgb(119 0 255 / var(--tw-text-opacity, 1));
}

.text-\\[\\#7700ff\\] {
  --tw-text-opacity: 1;
  color: rgb(119 0 255 / var(--tw-text-opacity, 1));
}

.text-\\[\\#7F7F7F\\] {
  --tw-text-opacity: 1;
  color: rgb(127 127 127 / var(--tw-text-opacity, 1));
}

.text-\\[\\#893EFF\\] {
  --tw-text-opacity: 1;
  color: rgb(137 62 255 / var(--tw-text-opacity, 1));
}

.text-\\[\\#8B5CF6\\] {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}

.text-\\[\\#8C8C8C\\] {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity, 1));
}

.text-\\[\\#8e01da\\] {
  --tw-text-opacity: 1;
  color: rgb(142 1 218 / var(--tw-text-opacity, 1));
}

.text-\\[\\#999\\] {
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}

.text-\\[\\#C6C6C6\\] {
  --tw-text-opacity: 1;
  color: rgb(198 198 198 / var(--tw-text-opacity, 1));
}

.text-\\[\\#D45EDB\\] {
  --tw-text-opacity: 1;
  color: rgb(212 94 219 / var(--tw-text-opacity, 1));
}

.text-\\[\\#E06187\\] {
  --tw-text-opacity: 1;
  color: rgb(224 97 135 / var(--tw-text-opacity, 1));
}

.text-\\[\\#E0E0E0\\] {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity, 1));
}

.text-\\[\\#FF0013\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 19 / var(--tw-text-opacity, 1));
}

.text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.text-customGray-250 {
  --tw-text-opacity: 1;
  color: rgb(180 180 180 / var(--tw-text-opacity, 1));
}

.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(239 239 239 / var(--tw-text-opacity, 1));
}

.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(218 218 218 / var(--tw-text-opacity, 1));
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(129 129 129 / var(--tw-text-opacity, 1));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(111 118 126 / var(--tw-text-opacity, 1));
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(64 75 83 / var(--tw-text-opacity, 1));
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(35 40 48 / var(--tw-text-opacity, 1));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(5 10 14 / var(--tw-text-opacity, 1));
}

.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(149 149 158 / var(--tw-text-opacity, 1));
}

.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(79 99 210 / var(--tw-text-opacity, 1));
}

.text-purple-750 {
  --tw-text-opacity: 1;
  color: rgb(98 70 251 / var(--tw-text-opacity, 1));
}

.text-red-150 {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity, 1));
}

.text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}

.text-red-250 {
  --tw-text-opacity: 1;
  color: rgb(255 98 98 / var(--tw-text-opacity, 1));
}

.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}

.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.text-slate-50 {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}

.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}

.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}

.text-opacity-60 {
  --tw-text-opacity: 0.6;
}

.underline {
  text-decoration-line: underline;
}

.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(129 129 129 / var(--tw-placeholder-opacity, 1));
}

.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(111 118 126 / var(--tw-placeholder-opacity, 1));
}

.accent-\\[\\#8A2BE2\\] {
  accent-color: #8A2BE2;
}

.accent-blue-500 {
  accent-color: #3b82f6;
}

.accent-white {
  accent-color: #fff;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-20 {
  opacity: 0.2;
}

.opacity-25 {
  opacity: 0.25;
}

.opacity-30 {
  opacity: 0.3;
}

.opacity-35 {
  opacity: 0.35;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-45 {
  opacity: 0.45;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-60 {
  opacity: 0.6;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-75 {
  opacity: 0.75;
}

.opacity-80 {
  opacity: 0.8;
}

.opacity-90 {
  opacity: 0.9;
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_0_0_4px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 0 4px rgba(124,58,237,0.25);
  --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_0_8px_rgba\\(120\\2c 61\\2c 249\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 8px rgba(120,61,249,0.6);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-\\[0_6px_14px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 6px 14px rgba(124,58,237,0.35);
  --tw-shadow-colored: 0 6px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-\\[\\#7700FF\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 0 255 / var(--tw-ring-opacity, 1));
}

.ring-\\[\\#7700ff\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 0 255 / var(--tw-ring-opacity, 1));
}

.ring-\\[\\#783DF9\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(120 61 249 / var(--tw-ring-opacity, 1));
}

.ring-\\[\\#8800FF\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(136 0 255 / var(--tw-ring-opacity, 1));
}

.ring-\\[\\#8A2BE2\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(138 43 226 / var(--tw-ring-opacity, 1));
}

.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}

.ring-gray-250 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 67 70 / var(--tw-ring-opacity, 1));
}

.ring-purple-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(70 88 187 / var(--tw-ring-opacity, 1));
}

.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}

.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}

.ring-offset-white {
  --tw-ring-offset-color: #fff;
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.brightness-110 {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.delay-1000 {
  transition-delay: 1000ms;
}

.duration-150 {
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

@keyframes bounce-subtle {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

@keyframes pulse-arrow {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

@keyframes slide-up-down {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

.collapse-button-animate {
  animation: bounce-subtle 2s ease-in-out infinite;
}

.expand-button-animate {
  animation: slide-up-down 2s ease-in-out infinite;
}

.arrow-pulse-animate {
  animation: pulse-arrow 1.5s ease-in-out infinite;
}

html {
  touch-action: pan-x pan-y;
  -ms-touch-action: pan-x pan-y;
  max-width: 100%;
  overflow-x: hidden;
}

body {
  margin: 0;
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: pan-x pan-y;
  -ms-touch-action: pan-x pan-y;
  max-width: 100%;
  overflow-x: hidden;
}

input,
textarea {
  -webkit-user-select: text;
  user-select: text;
}

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: "transparent";
  /* #212032; */
}

::-webkit-scrollbar-thumb {
  background: #1178f880;
}

::-webkit-scrollbar-thumb:hover {
  background: #1178f8;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

div .button {
  margin: 0 15px 15px 0;
}
.video-contain video {
  object-fit: contain;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
textarea:focus {
  outline: none;
  border-color: none;
  box-shadow: none;
}

input:focus-visible {
  outline: none;
  border-color: none;
  box-shadow: none;
}

.video-cover {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.video-cover video {
  position: absolute;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.video-cover-single {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.video-cover-single video {
  position: absolute;
  object-fit: contain;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

/* Custom scrollbar for participant grid during presentation */
.participant-grid-scrollbar::-webkit-scrollbar {
  height: 8px;
}

.participant-grid-scrollbar::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.participant-grid-scrollbar::-webkit-scrollbar-thumb {
  background: #4B5563;
  border-radius: 4px;
}

.participant-grid-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #6B7280;
}

input[type="radio"]:checked + label span {
  background-color: #fff;
  box-shadow: 0px 0px 0px 2px black inset;
}

input[type="radio"]:checked + label {
  color: #fff;
}

.flying-emojis {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  z-index: 99;
}
.emoji {
  position: absolute;
  bottom: 0px;
  left: 50%;
  font-size: 48px;
  line-height: 1;
  width: 48px;
  height: 48px;
}
.emoji.wiggle-1 {
  animation: emerge 3s forwards, wiggle-1 1s ease-in-out infinite alternate;
}
.emoji.wiggle-2 {
  animation: emerge 3s forwards, wiggle-2 1s ease-in-out infinite alternate;
}
@keyframes emerge {
  to {
    bottom: 85%;
    opacity: 0;
  }
}
@keyframes wiggle-1 {
  from {
    margin-left: -50px;
  }
  to {
    margin-left: 50px;
  }
}
@keyframes wiggle-2 {
  from {
    margin-left: 50px;
  }
  to {
    margin-left: -50px;
  }
}

.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.carousel-open:checked + .carousel-item {
  position: static;
  opacity: 100;
}

.carousel-item {
  position: absolute;
  opacity: 0;
  transition: opacity 0.6s ease-out;
}

.carousel-item img {
  display: block;
  height: auto;
  max-width: 100%;
}

.carousel-control {
  background: rgba(0, 0, 0, 0.28);
  border-radius: 50%;
  color: #fff;
  display: none;
  font-size: 30px;
  height: 35px;
  line-height: 30px;
  position: absolute;
  top: 25%;
  -webkit-transform: translate(0, -50%);
  cursor: pointer;
  transform: translate(0, -50%);
  text-align: center;
  width: 35px;
  z-index: 10;
}

.carousel-control.prev {
  left: 2%;
}

.carousel-control.next {
  right: 2%;
}

.carousel-control:hover {
  background: rgba(0, 0, 0, 0.8);
  color: #aaaaaa;
}

#carousel-1:checked ~ .control-1,
#carousel-2:checked ~ .control-2,
#carousel-3:checked ~ .control-3 {
  display: block;
}

.Toastify__toast-body {
  display: block !important;
  white-space: normal !important;
  color: black;
  font-weight: bolder;
}

.portal-background {
  background: linear-gradient(
    283deg,
    #2b2a3c 4.35%,
    #363347 49.25%,
    #615b72 95.98%
  );
}

.primary-card-background {
  background: rgba(0, 0, 0, 0.12);
}

/* Reconnecting UI Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes progress {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out;
}

.animate-scaleIn {
  animation: scaleIn 0.4s ease-out;
}

.animate-progress {
  animation: progress 2s ease-in-out infinite;
}

/* Hide PDFTron WebViewer header and toolbars - Comprehensive selectors */
#document-viewer .DocumentHeader,
#document-viewer .Header,
#document-viewer [data-element="documentHeader"],
#document-viewer .header,
#document-viewer .Toolbar,
#document-viewer .toolbar,
#document-viewer [data-element*="toolbar"],
#document-viewer [data-element*="Toolbar"],
#document-viewer .Ribbon,
#document-viewer .ribbon,
#document-viewer .ToolsHeader,
#document-viewer .toolsHeader,
#document-viewer [data-element="toolsHeader"],
#document-viewer .ToolbarGroup,
#document-viewer [class*="toolbar"],
#document-viewer [class*="Toolbar"],
#document-viewer [class*="Header"],
#document-viewer [class*="header"],
#document-viewer [id*="toolbar"],
#document-viewer [id*="Toolbar"],
#document-viewer [id*="header"],
#document-viewer [id*="Header"],
#document-viewer div[class*="Toolbar"],
#document-viewer div[class*="toolbar"],
#document-viewer div[class*="Header"],
#document-viewer nav[class*="Toolbar"],
#document-viewer nav[class*="toolbar"],
#document-viewer header,
#document-viewer nav {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  overflow: hidden !important;
  max-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Target iframe content if WebViewer uses iframe */
#document-viewer iframe .DocumentHeader,
#document-viewer iframe .Header,
#document-viewer iframe [data-element="documentHeader"],
#document-viewer iframe .header,
#document-viewer iframe .Toolbar,
#document-viewer iframe .toolbar,
#document-viewer iframe [data-element*="toolbar"],
#document-viewer iframe [class*="toolbar"],
#document-viewer iframe [class*="Toolbar"],
#document-viewer iframe [class*="Header"],
#document-viewer iframe header,
#document-viewer iframe nav {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  overflow: hidden !important;
}

/* More aggressive global rules for WebViewer */
#document-viewer > * > header,
#document-viewer > * > nav,
#document-viewer > header,
#document-viewer > nav,
#document-viewer header,
#document-viewer nav {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  max-height: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Target any element with toolbar/header in class or id anywhere in document-viewer */
/* But preserve navigation elements */
#document-viewer
  [class*="Toolbar"]:not([class*="Navigation"]):not([class*="navigation"]):not(
    [class*="Page"]
  ):not([class*="page"]),
#document-viewer
  [class*="toolbar"]:not([class*="Navigation"]):not([class*="navigation"]):not(
    [class*="Page"]
  ):not([class*="page"]),
#document-viewer [class*="Header"],
#document-viewer [class*="header"],
#document-viewer [id*="toolbar"]:not([id*="navigation"]):not([id*="page"]),
#document-viewer [id*="Toolbar"]:not([id*="Navigation"]):not([id*="Page"]),
#document-viewer [id*="header"],
#document-viewer [id*="Header"] {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  max-height: 0 !important;
  overflow: hidden !important;
}

/* Show navigation and page controls */
#document-viewer [data-element*="navigation"],
#document-viewer [data-element*="Navigation"],
#document-viewer [data-element*="page"],
#document-viewer [data-element*="Page"],
#document-viewer [class*="Navigation"],
#document-viewer [class*="navigation"],
#document-viewer [class*="PageControl"],
#document-viewer [class*="page-control"] {
  display: flex !important;
  visibility: visible !important;
}

/* Presentation mode styling */
#document-viewer {
  background-color: #1a1a1a !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

body.ios-pseudo-fullscreen,
body.ios-pseudo-fullscreen #root {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden !important;
  background-color: #000 !important;
  touch-action: none !important;
}

/* Ensure app root never exceeds viewport width */
#root {
  max-width: 100vw;
  overflow-x: hidden;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
  #document-viewer {
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
    height: 100vh !important;
    top: 0 !important;
    bottom: 0 !important;
  }

  #document-viewer .Page,
  #document-viewer .page,
  #document-viewer [class*="Page"] {
    max-width: 100% !important;
    height: auto !important;
  }
}

/* Center the document content in presentation mode */
#document-viewer .DocumentContainer,
#document-viewer .documentContainer,
#document-viewer [class*="Document"],
#document-viewer [class*="document"] {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: #1a1a1a !important;
}

/* Style pages for presentation */
#document-viewer .Page,
#document-viewer .page,
#document-viewer [class*="Page"] {
  margin: 0 auto !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;
}
.file\\:mr-4::file-selector-button {
  margin-right: 1rem;
}
.file\\:cursor-pointer::file-selector-button {
  cursor: pointer;
}
.file\\:rounded-lg::file-selector-button {
  border-radius: 0.5rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-\\[\\#6A1FBF\\]::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(106 31 191 / var(--tw-bg-opacity, 1));
}
.file\\:px-4::file-selector-button {
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-2::file-selector-button {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}
.file\\:text-white::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#606060\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(96 96 96 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#758195\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(117 129 149 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#999\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(129 129 129 / var(--tw-text-opacity, 1));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-\\[2px\\]::after {
  content: var(--tw-content);
  left: 2px;
}
.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}
.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#7700ff\\]\\/80:hover {
  border-color: rgb(119 0 255 / 0.8);
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(218 218 218 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 129 129 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(111 118 126 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(64 75 83 / var(--tw-border-opacity, 1));
}
.hover\\:border-indigo-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#00C853\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 200 83 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#12a043\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(18 160 67 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1CD760\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 215 96 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1a1a2e\\]\\/80:hover {
  background-color: rgb(26 26 46 / 0.8);
}
.hover\\:bg-\\[\\#1ab850\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 184 80 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#1ed760\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 215 96 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#3A285F\\]\\/80:hover {
  background-color: rgb(58 40 95 / 0.8);
}
.hover\\:bg-\\[\\#462091\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(70 32 145 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5A2AA3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 42 163 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5a6578\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 101 120 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#6600DD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(102 0 221 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#6A1FBF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(106 31 191 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#6a00e6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(106 0 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#7700FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(119 0 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#7700FF\\]\\/80:hover {
  background-color: rgb(119 0 255 / 0.8);
}
.hover\\:bg-\\[\\#7700ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(119 0 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#7700ff\\]\\/80:hover {
  background-color: rgb(119 0 255 / 0.8);
}
.hover\\:bg-\\[\\#7B2FCF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(123 47 207 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#9933ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 51 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FAD0E3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 208 227 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#b91c1c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#ffffff2f\\]:hover {
  background-color: #ffffff2f;
}
.hover\\:bg-\\[\\#ffffff33\\]:hover {
  background-color: #ffffff33;
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/50:hover {
  background-color: rgb(0 0 0 / 0.5);
}
.hover\\:bg-black\\/60:hover {
  background-color: rgb(0 0 0 / 0.6);
}
.hover\\:bg-black\\/70:hover {
  background-color: rgb(0 0 0 / 0.7);
}
.hover\\:bg-black\\/80:hover {
  background-color: rgb(0 0 0 / 0.8);
}
.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200\\/70:hover {
  background-color: rgb(239 239 239 / 0.7);
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(218 218 218 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(129 129 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(85 85 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(111 118 126 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(64 75 83 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600\\/50:hover {
  background-color: rgb(64 75 83 / 0.5);
}
.hover\\:bg-gray-600\\/80:hover {
  background-color: rgb(64 75 83 / 0.8);
}
.hover\\:bg-gray-600\\/90:hover {
  background-color: rgb(64 75 83 / 0.9);
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(35 40 48 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-700\\/30:hover {
  background-color: rgb(35 40 48 / 0.3);
}
.hover\\:bg-gray-700\\/50:hover {
  background-color: rgb(35 40 48 / 0.5);
}
.hover\\:bg-gray-800\\/60:hover {
  background-color: rgb(5 10 14 / 0.6);
}
.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(149 149 158 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primaryPurple\\/80:hover {
  background-color: rgb(119 0 255 / 0.8);
}
.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(88 111 234 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 99 210 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-600\\/10:hover {
  background-color: rgb(220 38 38 / 0.1);
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-\\[\\#6600dd\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(102 0 221 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 10 14 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-10:hover {
  --tw-bg-opacity: 0.1;
}
.hover\\:bg-opacity-20:hover {
  --tw-bg-opacity: 0.2;
}
.hover\\:bg-opacity-30:hover {
  --tw-bg-opacity: 0.3;
}
.hover\\:from-purple-700:hover {
  --tw-gradient-from: #4F63D2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 99 210 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:text-\\[\\#7700ff\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(119 0 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-300:hover {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(239 239 239 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(218 218 218 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(64 75 83 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(35 40 48 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(5 10 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-300:hover {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:no-underline:hover {
  text-decoration-line: none;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-gray-250:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 67 70 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-gray-500:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(111 118 126 / var(--tw-ring-opacity, 1));
}
.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:file\\:bg-\\[\\#7B2FCF\\]::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(123 47 207 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-indigo-700::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.focus\\:border-\\[\\#1CD760\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(28 215 96 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#7700FF\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(119 0 255 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#7700ff\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(119 0 255 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-700:focus {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#00C853\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 200 83 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#1CD760\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 215 96 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#6A1FBF\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(106 31 191 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#7700ff\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 0 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#7700ff\\]\\/40:focus {
  --tw-ring-color: rgb(119 0 255 / 0.4);
}
.focus\\:ring-\\[\\#8A2BE2\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(138 43 226 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-550:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(89 107 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-gray-200:active {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity, 1));
}
.active\\:bg-gray-600:active {
  --tw-bg-opacity: 1;
  background-color: rgb(64 75 83 / var(--tw-bg-opacity, 1));
}
.active\\:bg-white\\/40:active {
  background-color: rgb(255 255 255 / 0.4);
}
.active\\:bg-\\[\\#5500BB\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(85 0 187 / var(--tw-bg-opacity, 1));
}
.active\\:bg-gray-700:active {
  --tw-bg-opacity: 1;
  background-color: rgb(35 40 48 / var(--tw-bg-opacity, 1));
}
.active\\:bg-white\\/30:active {
  background-color: rgb(255 255 255 / 0.3);
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-gray-500:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(111 118 126 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-600:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(64 75 83 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-700:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(35 40 48 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-primaryPurple\\/40:disabled {
  background-color: rgb(119 0 255 / 0.4);
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(64 75 83 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
@media (max-width: 425px) {

  .max-\\[425px\\]\\:left-2 {
    left: 0.5rem;
  }

  .max-\\[425px\\]\\:right-2 {
    right: 0.5rem;
  }
}
@media (min-width: 640px) {

  .sm\\:invisible {
    visibility: hidden;
  }

  .sm\\:bottom-6 {
    bottom: 1.5rem;
  }

  .sm\\:bottom-\\[15vh\\] {
    bottom: 15vh;
  }

  .sm\\:left-0 {
    left: 0px;
  }

  .sm\\:top-10 {
    top: 2.5rem;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .sm\\:m-3 {
    margin: 0.75rem;
  }

  .sm\\:mb-12 {
    margin-bottom: 3rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:ml-\\[10\\%\\] {
    margin-left: 10%;
  }

  .sm\\:mr-0 {
    margin-right: 0px;
  }

  .sm\\:mr-8 {
    margin-right: 2rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:mt-\\[5\\%\\] {
    margin-top: 5%;
  }

  .sm\\:mt-\\[50px\\] {
    margin-top: 50px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-0 {
    height: 0px;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-11 {
    height: 2.75rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-3\\.5 {
    height: 0.875rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-8 {
    height: 2rem;
  }

  .sm\\:h-\\[100px\\] {
    height: 100px;
  }

  .sm\\:h-\\[110px\\] {
    height: 110px;
  }

  .sm\\:h-\\[120px\\] {
    height: 120px;
  }

  .sm\\:h-\\[140px\\] {
    height: 140px;
  }

  .sm\\:h-\\[250px\\] {
    height: 250px;
  }

  .sm\\:h-\\[90px\\] {
    height: 90px;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:max-h-\\[400px\\] {
    max-height: 400px;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-20 {
    width: 5rem;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-3\\.5 {
    width: 0.875rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-7 {
    width: 1.75rem;
  }

  .sm\\:w-8 {
    width: 2rem;
  }

  .sm\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .sm\\:w-\\[100px\\] {
    width: 100px;
  }

  .sm\\:w-\\[140px\\] {
    width: 140px;
  }

  .sm\\:w-\\[160px\\] {
    width: 160px;
  }

  .sm\\:w-\\[180px\\] {
    width: 180px;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-\\[240px\\] {
    width: 240px;
  }

  .sm\\:w-\\[65px\\] {
    width: 65px;
  }

  .sm\\:w-\\[70px\\] {
    width: 70px;
  }

  .sm\\:w-\\[80px\\] {
    width: 80px;
  }

  .sm\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .sm\\:w-\\[90px\\] {
    width: 90px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[158px\\] {
    min-width: 158px;
  }

  .sm\\:max-w-\\[120px\\] {
    max-width: 120px;
  }

  .sm\\:max-w-\\[140px\\] {
    max-width: 140px;
  }

  .sm\\:max-w-\\[240px\\] {
    max-width: 240px;
  }

  .sm\\:max-w-\\[320px\\] {
    max-width: 320px;
  }

  .sm\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-20 {
    gap: 5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:gap-x-4 {
    column-gap: 1rem;
  }

  .sm\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:overflow-y-auto {
    overflow-y: auto;
  }

  .sm\\:break-normal {
    overflow-wrap: normal;
    word-break: normal;
  }

  .sm\\:break-words {
    overflow-wrap: break-word;
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-1 {
    padding: 0.25rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }

  .sm\\:pl-10 {
    padding-left: 2.5rem;
  }

  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }

  .sm\\:pt-\\[12\\%\\] {
    padding-top: 12%;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[0\\.7rem\\] {
    font-size: 0.7rem;
  }

  .sm\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:relative {
    position: relative;
  }

  .md\\:bottom-0 {
    bottom: 0px;
  }

  .md\\:left-0 {
    left: 0px;
  }

  .md\\:right-0 {
    right: 0px;
  }

  .md\\:right-2 {
    right: 0.5rem;
  }

  .md\\:right-3 {
    right: 0.75rem;
  }

  .md\\:right-8 {
    right: 2rem;
  }

  .md\\:right-auto {
    right: auto;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:top-16 {
    top: 4rem;
  }

  .md\\:top-2 {
    top: 0.5rem;
  }

  .md\\:top-20 {
    top: 5rem;
  }

  .md\\:top-3 {
    top: 0.75rem;
  }

  .md\\:top-\\[150px\\] {
    top: 150px;
  }

  .md\\:top-\\[60px\\] {
    top: 60px;
  }

  .md\\:top-\\[90px\\] {
    top: 90px;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:-m-2 {
    margin: -0.5rem;
  }

  .md\\:m-2 {
    margin: 0.5rem;
  }

  .md\\:m-\\[30px\\] {
    margin: 30px;
  }

  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:ml-16 {
    margin-left: 4rem;
  }

  .md\\:ml-56 {
    margin-left: 14rem;
  }

  .md\\:ml-\\[22rem\\] {
    margin-left: 22rem;
  }

  .md\\:ml-\\[8\\%\\] {
    margin-left: 8%;
  }

  .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .md\\:mr-3 {
    margin-right: 0.75rem;
  }

  .md\\:mr-4 {
    margin-right: 1rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-6 {
    margin-top: 1.5rem;
  }

  .md\\:mt-8 {
    margin-top: 2rem;
  }

  .md\\:mt-9 {
    margin-top: 2.25rem;
  }

  .md\\:mt-\\[0\\%\\] {
    margin-top: 0%;
  }

  .md\\:mt-\\[1\\%\\] {
    margin-top: 1%;
  }

  .md\\:mt-\\[15\\%\\] {
    margin-top: 15%;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-12 {
    height: 3rem;
  }

  .md\\:h-14 {
    height: 3.5rem;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:h-28 {
    height: 7rem;
  }

  .md\\:h-3\\.5 {
    height: 0.875rem;
  }

  .md\\:h-32 {
    height: 8rem;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-40 {
    height: 10rem;
  }

  .md\\:h-48 {
    height: 12rem;
  }

  .md\\:h-5 {
    height: 1.25rem;
  }

  .md\\:h-6 {
    height: 1.5rem;
  }

  .md\\:h-64 {
    height: 16rem;
  }

  .md\\:h-7 {
    height: 1.75rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-96 {
    height: 24rem;
  }

  .md\\:h-\\[100px\\] {
    height: 100px;
  }

  .md\\:h-\\[120px\\] {
    height: 120px;
  }

  .md\\:h-\\[140px\\] {
    height: 140px;
  }

  .md\\:h-\\[160px\\] {
    height: 160px;
  }

  .md\\:h-\\[180px\\] {
    height: 180px;
  }

  .md\\:h-\\[18px\\] {
    height: 18px;
  }

  .md\\:h-\\[300px\\] {
    height: 300px;
  }

  .md\\:h-\\[60px\\] {
    height: 60px;
  }

  .md\\:h-\\[calc\\(100vh-100px-80px\\)\\] {
    height: calc(100vh - 100px - 80px);
  }

  .md\\:h-\\[calc\\(100vh-60px-2rem\\)\\] {
    height: calc(100vh - 60px - 2rem);
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:h-1 {
    height: 0.25rem;
  }

  .md\\:h-1\\.5 {
    height: 0.375rem;
  }

  .md\\:max-h-\\[500px\\] {
    max-height: 500px;
  }

  .md\\:max-h-\\[703px\\] {
    max-height: 703px;
  }

  .md\\:max-h-full {
    max-height: 100%;
  }

  .md\\:max-h-none {
    max-height: none;
  }

  .md\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .md\\:min-h-44 {
    min-height: 11rem;
  }

  .md\\:min-h-\\[120px\\] {
    min-height: 120px;
  }

  .md\\:min-h-\\[150px\\] {
    min-height: 150px;
  }

  .md\\:min-h-\\[300px\\] {
    min-height: 300px;
  }

  .md\\:min-h-\\[320px\\] {
    min-height: 320px;
  }

  .md\\:min-h-\\[400px\\] {
    min-height: 400px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-12 {
    width: 3rem;
  }

  .md\\:w-14 {
    width: 3.5rem;
  }

  .md\\:w-16 {
    width: 4rem;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-20 {
    width: 5rem;
  }

  .md\\:w-24 {
    width: 6rem;
  }

  .md\\:w-3 {
    width: 0.75rem;
  }

  .md\\:w-3\\.5 {
    width: 0.875rem;
  }

  .md\\:w-32 {
    width: 8rem;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-4\\/5 {
    width: 80%;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-5 {
    width: 1.25rem;
  }

  .md\\:w-6 {
    width: 1.5rem;
  }

  .md\\:w-60 {
    width: 15rem;
  }

  .md\\:w-64 {
    width: 16rem;
  }

  .md\\:w-7 {
    width: 1.75rem;
  }

  .md\\:w-8 {
    width: 2rem;
  }

  .md\\:w-80 {
    width: 20rem;
  }

  .md\\:w-\\[100px\\] {
    width: 100px;
  }

  .md\\:w-\\[110px\\] {
    width: 110px;
  }

  .md\\:w-\\[120px\\] {
    width: 120px;
  }

  .md\\:w-\\[180px\\] {
    width: 180px;
  }

  .md\\:w-\\[18px\\] {
    width: 18px;
  }

  .md\\:w-\\[200px\\] {
    width: 200px;
  }

  .md\\:w-\\[240px\\] {
    width: 240px;
  }

  .md\\:w-\\[280px\\] {
    width: 280px;
  }

  .md\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .md\\:w-\\[320px\\] {
    width: 320px;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-\\[85px\\] {
    width: 85px;
  }

  .md\\:w-\\[90px\\] {
    width: 90px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-\\[220px\\] {
    min-width: 220px;
  }

  .md\\:min-w-\\[420px\\] {
    min-width: 420px;
  }

  .md\\:max-w-\\[140px\\] {
    max-width: 140px;
  }

  .md\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:max-w-full {
    max-width: 100%;
  }

  .md\\:max-w-lg {
    max-width: 32rem;
  }

  .md\\:max-w-6xl {
    max-width: 72rem;
  }

  .md\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-12 {
    gap: 3rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:gap-x-24 {
    column-gap: 6rem;
  }

  .md\\:gap-y-4 {
    row-gap: 1rem;
  }

  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--tw-space-x-reverse));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .md\\:space-y-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse));
  }

  .md\\:overflow-hidden {
    overflow: hidden;
  }

  .md\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .md\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .md\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .md\\:p-0\\.5 {
    padding: 0.125rem;
  }

  .md\\:p-1 {
    padding: 0.25rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:p-\\[6px\\] {
    padding: 6px;
  }

  .md\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:px-\\[22px\\] {
    padding-left: 22px;
    padding-right: 22px;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .md\\:pb-0 {
    padding-bottom: 0px;
  }

  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pr-10 {
    padding-right: 2.5rem;
  }

  .md\\:pr-3 {
    padding-right: 0.75rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  .md\\:pt-20 {
    padding-top: 5rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }

  .md\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .md\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .md\\:text-\\[33px\\] {
    font-size: 33px;
  }

  .md\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .md\\:text-\\[8px\\] {
    font-size: 8px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .md\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 1024px) {

  .lg\\:bottom-8 {
    bottom: 2rem;
  }

  .lg\\:left-1\\/2 {
    left: 50%;
  }

  .lg\\:m-16 {
    margin: 4rem;
  }

  .lg\\:m-6 {
    margin: 1.5rem;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:ml-3 {
    margin-left: 0.75rem;
  }

  .lg\\:ml-\\[10\\%\\] {
    margin-left: 10%;
  }

  .lg\\:mr-\\[10\\%\\] {
    margin-right: 10%;
  }

  .lg\\:mt-14 {
    margin-top: 3.5rem;
  }

  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }

  .lg\\:mt-20 {
    margin-top: 5rem;
  }

  .lg\\:mt-\\[10\\%\\] {
    margin-top: 10%;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-4 {
    height: 1rem;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-7 {
    height: 1.75rem;
  }

  .lg\\:h-8 {
    height: 2rem;
  }

  .lg\\:h-\\[80\\%\\] {
    height: 80%;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:min-h-screen {
    min-height: 100vh;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-4 {
    width: 1rem;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:w-64 {
    width: 16rem;
  }

  .lg\\:w-7 {
    width: 1.75rem;
  }

  .lg\\:w-8 {
    width: 2rem;
  }

  .lg\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .lg\\:max-w-\\[180px\\] {
    max-width: 180px;
  }

  .lg\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-2 {
    gap: 0.5rem;
  }

  .lg\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-7 {
    gap: 1.75rem;
  }

  .lg\\:gap-x-40 {
    column-gap: 10rem;
  }

  .lg\\:space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
  }

  .lg\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:bg-cover {
    background-size: cover;
  }

  .lg\\:bg-center {
    background-position: center;
  }

  .lg\\:bg-no-repeat {
    background-repeat: no-repeat;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pl-\\[4\\%\\] {
    padding-left: 4%;
  }

  .lg\\:pt-\\[13\\%\\] {
    padding-top: 13%;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-\\[0\\.8rem\\] {
    font-size: 0.8rem;
  }

  .lg\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .lg\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:bottom-6 {
    bottom: 1.5rem;
  }

  .xl\\:m-16 {
    margin: 4rem;
  }

  .xl\\:mr-10 {
    margin-right: 2.5rem;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:mt-20 {
    margin-top: 5rem;
  }

  .xl\\:h-20 {
    height: 5rem;
  }

  .xl\\:h-8 {
    height: 2rem;
  }

  .xl\\:h-\\[120px\\] {
    height: 120px;
  }

  .xl\\:h-\\[140px\\] {
    height: 140px;
  }

  .xl\\:h-\\[160px\\] {
    height: 160px;
  }

  .xl\\:h-\\[180px\\] {
    height: 180px;
  }

  .xl\\:h-\\[200px\\] {
    height: 200px;
  }

  .xl\\:w-64 {
    width: 16rem;
  }

  .xl\\:w-8 {
    width: 2rem;
  }

  .xl\\:w-\\[200px\\] {
    width: 200px;
  }

  .xl\\:w-\\[240px\\] {
    width: 240px;
  }

  .xl\\:w-\\[280px\\] {
    width: 280px;
  }

  .xl\\:w-\\[320px\\] {
    width: 320px;
  }

  .xl\\:w-\\[360px\\] {
    width: 360px;
  }

  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:gap-2 {
    gap: 0.5rem;
  }

  .xl\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .xl\\:gap-3 {
    gap: 0.75rem;
  }

  .xl\\:gap-x-48 {
    column-gap: 12rem;
  }

  .xl\\:p-2 {
    padding: 0.5rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .\\32xl\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .\\32xl\\:mr-12 {
    margin-right: 3rem;
  }

  .\\32xl\\:h-\\[140px\\] {
    height: 140px;
  }

  .\\32xl\\:h-\\[160px\\] {
    height: 160px;
  }

  .\\32xl\\:h-\\[180px\\] {
    height: 180px;
  }

  .\\32xl\\:h-\\[200px\\] {
    height: 200px;
  }

  .\\32xl\\:h-\\[220px\\] {
    height: 220px;
  }

  .\\32xl\\:h-\\[92px\\] {
    height: 92px;
  }

  .\\32xl\\:w-80 {
    width: 20rem;
  }

  .\\32xl\\:w-\\[240px\\] {
    width: 240px;
  }

  .\\32xl\\:w-\\[280px\\] {
    width: 280px;
  }

  .\\32xl\\:w-\\[320px\\] {
    width: 320px;
  }

  .\\32xl\\:w-\\[360px\\] {
    width: 360px;
  }

  .\\32xl\\:w-\\[400px\\] {
    width: 400px;
  }

  .\\32xl\\:w-\\[92px\\] {
    width: 92px;
  }

  .\\32xl\\:max-w-2xl {
    max-width: 42rem;
  }

  .\\32xl\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .\\32xl\\:max-w-full {
    max-width: 100%;
  }

  .\\32xl\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .\\32xl\\:gap-3 {
    gap: 0.75rem;
  }

  .\\32xl\\:gap-4 {
    gap: 1rem;
  }
}
@media (prefers-color-scheme: dark) {

  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(35 40 48 / var(--tw-bg-opacity, 1));
  }

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(129 129 129 / var(--tw-text-opacity, 1));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4KAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,8CAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAEd;EAAA;AAAoB;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AAEpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAEnB;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAcA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;;AAEA,8DAA8D;AAC9D;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EAEV,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EAEX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,eAAe;EAEf,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,yEAAyE;AACzE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BE,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;;;;;;;;;;;;EAYE,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;;;;;;EAME,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,sFAAsF;AACtF,qCAAqC;AACrC;;;;;;;;;;;;;;EAcE,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;;;;;;;;EAQE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,2BAA2B;IAC3B,4CAA4C;IAC5C,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;;;IAGE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;;AAEA,qDAAqD;AACrD;;;;EAIE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,iCAAiC;AACjC;;;EAGE,yBAAyB;EACzB,oDAAoD;AACtD;AA7hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,mBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,mBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA,wBA8hBA;EA9hBA,wDA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,gBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,2BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,iBA8hBA;EA9hBA,iBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,4DA8hBA;EA9hBA,mEA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,+EA8hBA;EA9hBA,mGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,gFA8hBA;EA9hBA,oGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,2GA8hBA;EA9hBA,yGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,2GA8hBA;EA9hBA,yGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,gCA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,8BA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,2GA8hBA;EA9hBA,yGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,2GA8hBA;EA9hBA,yGA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,iBA8hBA;EA9hBA,iBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,iBA8hBA;EA9hBA,iBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,oBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,kBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,0BA8hBA;EA9hBA,sBA8hBA;EA9hBA;AA8hBA;AA9hBA;EAAA,8BA8hBA;EA9hBA;AA8hBA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,+DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,4DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,+DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,eA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,sDA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,oDA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,sDA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,2DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,8DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,+DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,4DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,+DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,8DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,4DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,gBA8hBA;IA9hBA,uBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,gCA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,4BA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,sBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,gBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,eA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,eA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,mBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,gBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,sBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,uBA8hBA;IA9hBA,+DA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,qBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,iBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,kBA8hBA;IA9hBA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;;EA9hBA;IAAA;EA8hBA;AAAA;AA9hBA;;EAAA;IAAA,kBA8hBA;IA9hBA;EA8hBA;;EA9hBA;IAAA,oBA8hBA;IA9hBA;EA8hBA;AAAA","sourcesContent":["@tailwind base;\n\n@tailwind components;\n\n@tailwind utilities;\n\n@keyframes bounce-subtle {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-4px);\n  }\n}\n\n@keyframes pulse-arrow {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.1);\n  }\n}\n\n@keyframes slide-up-down {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-3px);\n  }\n}\n\n.collapse-button-animate {\n  animation: bounce-subtle 2s ease-in-out infinite;\n}\n\n.expand-button-animate {\n  animation: slide-up-down 2s ease-in-out infinite;\n}\n\n.arrow-pulse-animate {\n  animation: pulse-arrow 1.5s ease-in-out infinite;\n}\n\n@layer utilities {\n  \n  .scrollbar-hide {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n  \n  .scrollbar-hide::-webkit-scrollbar {\n    display: none; /* Chrome, Safari and Opera */\n  }\n}\n\nhtml {\n  touch-action: pan-x pan-y;\n  -ms-touch-action: pan-x pan-y;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  touch-action: pan-x pan-y;\n  -ms-touch-action: pan-x pan-y;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\ninput,\ntextarea {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n::-webkit-scrollbar {\n  width: 4px;\n}\n\n::-webkit-scrollbar-track {\n  background: \"transparent\";\n  /* #212032; */\n}\n\n::-webkit-scrollbar-thumb {\n  background: #1178f880;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #1178f8;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\ndiv .button {\n  margin: 0 15px 15px 0;\n}\n.video-contain video {\n  object-fit: contain;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\ntextarea:focus {\n  outline: none;\n  border-color: none;\n  box-shadow: none;\n}\n\ninput:focus-visible {\n  outline: none;\n  border-color: none;\n  box-shadow: none;\n}\n\n.video-cover {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.video-cover video {\n  position: absolute;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n.video-cover-single {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.video-cover-single video {\n  position: absolute;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n\n/* Custom scrollbar for participant grid during presentation */\n.participant-grid-scrollbar::-webkit-scrollbar {\n  height: 8px;\n}\n\n.participant-grid-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 4px;\n}\n\n.participant-grid-scrollbar::-webkit-scrollbar-thumb {\n  background: #4B5563;\n  border-radius: 4px;\n}\n\n.participant-grid-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #6B7280;\n}\n\ninput[type=\"radio\"]:checked + label span {\n  background-color: #fff;\n  box-shadow: 0px 0px 0px 2px black inset;\n}\n\ninput[type=\"radio\"]:checked + label {\n  color: #fff;\n}\n\n.flying-emojis {\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  overflow: hidden;\n  pointer-events: none;\n  user-select: none;\n  z-index: 99;\n}\n.emoji {\n  position: absolute;\n  bottom: 0px;\n  left: 50%;\n  font-size: 48px;\n  line-height: 1;\n  width: 48px;\n  height: 48px;\n}\n.emoji.wiggle-1 {\n  animation: emerge 3s forwards, wiggle-1 1s ease-in-out infinite alternate;\n}\n.emoji.wiggle-2 {\n  animation: emerge 3s forwards, wiggle-2 1s ease-in-out infinite alternate;\n}\n@keyframes emerge {\n  to {\n    bottom: 85%;\n    opacity: 0;\n  }\n}\n@keyframes wiggle-1 {\n  from {\n    margin-left: -50px;\n  }\n  to {\n    margin-left: 50px;\n  }\n}\n@keyframes wiggle-2 {\n  from {\n    margin-left: 50px;\n  }\n  to {\n    margin-left: -50px;\n  }\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.carousel-open:checked + .carousel-item {\n  position: static;\n  opacity: 100;\n}\n\n.carousel-item {\n  position: absolute;\n  opacity: 0;\n  -webkit-transition: opacity 0.6s ease-out;\n  transition: opacity 0.6s ease-out;\n}\n\n.carousel-item img {\n  display: block;\n  height: auto;\n  max-width: 100%;\n}\n\n.carousel-control {\n  background: rgba(0, 0, 0, 0.28);\n  border-radius: 50%;\n  color: #fff;\n  cursor: pointer;\n  display: none;\n  font-size: 30px;\n  height: 35px;\n  line-height: 30px;\n  position: absolute;\n  top: 25%;\n  -webkit-transform: translate(0, -50%);\n  cursor: pointer;\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  text-align: center;\n  width: 35px;\n  z-index: 10;\n}\n\n.carousel-control.prev {\n  left: 2%;\n}\n\n.carousel-control.next {\n  right: 2%;\n}\n\n.carousel-control:hover {\n  background: rgba(0, 0, 0, 0.8);\n  color: #aaaaaa;\n}\n\n#carousel-1:checked ~ .control-1,\n#carousel-2:checked ~ .control-2,\n#carousel-3:checked ~ .control-3 {\n  display: block;\n}\n\n.Toastify__toast-body {\n  display: block !important;\n  white-space: normal !important;\n  color: black;\n  font-weight: bolder;\n}\n\n.portal-background {\n  background: linear-gradient(\n    283deg,\n    #2b2a3c 4.35%,\n    #363347 49.25%,\n    #615b72 95.98%\n  );\n}\n\n.primary-card-background {\n  background: rgba(0, 0, 0, 0.12);\n}\n\n/* Reconnecting UI Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes progress {\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.3s ease-out;\n}\n\n.animate-scaleIn {\n  animation: scaleIn 0.4s ease-out;\n}\n\n.animate-progress {\n  animation: progress 2s ease-in-out infinite;\n}\n\n/* Hide PDFTron WebViewer header and toolbars - Comprehensive selectors */\n#document-viewer .DocumentHeader,\n#document-viewer .Header,\n#document-viewer [data-element=\"documentHeader\"],\n#document-viewer .header,\n#document-viewer .Toolbar,\n#document-viewer .toolbar,\n#document-viewer [data-element*=\"toolbar\"],\n#document-viewer [data-element*=\"Toolbar\"],\n#document-viewer .Ribbon,\n#document-viewer .ribbon,\n#document-viewer .ToolsHeader,\n#document-viewer .toolsHeader,\n#document-viewer [data-element=\"toolsHeader\"],\n#document-viewer .ToolbarGroup,\n#document-viewer [class*=\"toolbar\"],\n#document-viewer [class*=\"Toolbar\"],\n#document-viewer [class*=\"Header\"],\n#document-viewer [class*=\"header\"],\n#document-viewer [id*=\"toolbar\"],\n#document-viewer [id*=\"Toolbar\"],\n#document-viewer [id*=\"header\"],\n#document-viewer [id*=\"Header\"],\n#document-viewer div[class*=\"Toolbar\"],\n#document-viewer div[class*=\"toolbar\"],\n#document-viewer div[class*=\"Header\"],\n#document-viewer nav[class*=\"Toolbar\"],\n#document-viewer nav[class*=\"toolbar\"],\n#document-viewer header,\n#document-viewer nav {\n  display: none !important;\n  visibility: hidden !important;\n  height: 0 !important;\n  overflow: hidden !important;\n  max-height: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n/* Target iframe content if WebViewer uses iframe */\n#document-viewer iframe .DocumentHeader,\n#document-viewer iframe .Header,\n#document-viewer iframe [data-element=\"documentHeader\"],\n#document-viewer iframe .header,\n#document-viewer iframe .Toolbar,\n#document-viewer iframe .toolbar,\n#document-viewer iframe [data-element*=\"toolbar\"],\n#document-viewer iframe [class*=\"toolbar\"],\n#document-viewer iframe [class*=\"Toolbar\"],\n#document-viewer iframe [class*=\"Header\"],\n#document-viewer iframe header,\n#document-viewer iframe nav {\n  display: none !important;\n  visibility: hidden !important;\n  height: 0 !important;\n  overflow: hidden !important;\n}\n\n/* More aggressive global rules for WebViewer */\n#document-viewer > * > header,\n#document-viewer > * > nav,\n#document-viewer > header,\n#document-viewer > nav,\n#document-viewer header,\n#document-viewer nav {\n  display: none !important;\n  visibility: hidden !important;\n  height: 0 !important;\n  max-height: 0 !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n/* Target any element with toolbar/header in class or id anywhere in document-viewer */\n/* But preserve navigation elements */\n#document-viewer\n  [class*=\"Toolbar\"]:not([class*=\"Navigation\"]):not([class*=\"navigation\"]):not(\n    [class*=\"Page\"]\n  ):not([class*=\"page\"]),\n#document-viewer\n  [class*=\"toolbar\"]:not([class*=\"Navigation\"]):not([class*=\"navigation\"]):not(\n    [class*=\"Page\"]\n  ):not([class*=\"page\"]),\n#document-viewer [class*=\"Header\"],\n#document-viewer [class*=\"header\"],\n#document-viewer [id*=\"toolbar\"]:not([id*=\"navigation\"]):not([id*=\"page\"]),\n#document-viewer [id*=\"Toolbar\"]:not([id*=\"Navigation\"]):not([id*=\"Page\"]),\n#document-viewer [id*=\"header\"],\n#document-viewer [id*=\"Header\"] {\n  display: none !important;\n  visibility: hidden !important;\n  height: 0 !important;\n  max-height: 0 !important;\n  overflow: hidden !important;\n}\n\n/* Show navigation and page controls */\n#document-viewer [data-element*=\"navigation\"],\n#document-viewer [data-element*=\"Navigation\"],\n#document-viewer [data-element*=\"page\"],\n#document-viewer [data-element*=\"Page\"],\n#document-viewer [class*=\"Navigation\"],\n#document-viewer [class*=\"navigation\"],\n#document-viewer [class*=\"PageControl\"],\n#document-viewer [class*=\"page-control\"] {\n  display: flex !important;\n  visibility: visible !important;\n}\n\n/* Presentation mode styling */\n#document-viewer {\n  background-color: #1a1a1a !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\nbody.ios-pseudo-fullscreen,\nbody.ios-pseudo-fullscreen #root {\n  position: fixed !important;\n  inset: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  overflow: hidden !important;\n  background-color: #000 !important;\n  touch-action: none !important;\n}\n\n/* Ensure app root never exceeds viewport width */\n#root {\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 768px) {\n  #document-viewer {\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    height: 100vh !important;\n    top: 0 !important;\n    bottom: 0 !important;\n  }\n\n  #document-viewer .Page,\n  #document-viewer .page,\n  #document-viewer [class*=\"Page\"] {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n}\n\n/* Center the document content in presentation mode */\n#document-viewer .DocumentContainer,\n#document-viewer .documentContainer,\n#document-viewer [class*=\"Document\"],\n#document-viewer [class*=\"document\"] {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background-color: #1a1a1a !important;\n}\n\n/* Style pages for presentation */\n#document-viewer .Page,\n#document-viewer .page,\n#document-viewer [class*=\"Page\"] {\n  margin: 0 auto !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
